import { createAsyncThunk } from "@reduxjs/toolkit";
import { translationsApi } from "../../api/translationsApi";
import { handleRequest } from "../utils/handleRequest";
import { AppDispatch, RootState } from "../store";
import i18n from "../../i18n";

export const fetchTranslations = createAsyncThunk<
    { entityType: string; entityId: string; property: string; data: Record<string, string> },
    { entityType: string; entityId: string; property: string },
    { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
    "translations/fetchTranslations",
    async ({ entityType, entityId, property }, { dispatch, rejectWithValue }) => {
        const callResult = await handleRequest(
            dispatch,
            "indirect",
            () => translationsApi.getTranslations(entityType, entityId, property)
        );
        if (callResult.success() && callResult.result) {
            return { entityType, entityId, property, data: callResult.result };
        }
        return rejectWithValue(callResult.errorMessage ?? "Failed to fetch translations");
    }
);

export const patchTranslationsThunk = createAsyncThunk<
    { entityType: string; entityId: string; property: string; translations: Record<string, string> },
    {
        entityType: string;
        entityId: string;
        property: string;
        translations: Record<string, string>;
        nestedId?: string[];
    },
    { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
    "translations/patchTranslations",
    async ({ entityType, entityId, property, translations, nestedId }, { dispatch, rejectWithValue }) => {
        const callResult = await handleRequest(
            dispatch,
            "direct",
            () => translationsApi.patchTranslations(entityType, entityId, property, translations, nestedId),
            i18n.t("requestMessage.translationsUpdated")
        );
        if (!callResult.success()) {
            return rejectWithValue(callResult.errorMessage ?? "Failed to patch translations");
        }
        await dispatch(fetchTranslations({ entityType, entityId, property }));
        return { entityType, entityId, property, translations };
    }
);